import React, { useContext } from "react";
import LProgressBar from "../LProgressBar/LProgressBar";

import "./LColapsedPlayer.css";
import usePlayerUtils from "../../hooks/usePlayerUtils";
import { useAudioVisualizer } from "../../hooks/useAudioVisualizer";
import { AuthContext } from "../../services/AuthContext";

function LColapsedPlayer({ wrapChildClick, togglePlay, onTabChevron, expanded }) {
    const {
        audioRef,
        currentTrack,
        nowPlaying,
        playbackState,
        setCurrentTimeSec,
        playbackTimeMs,
        currentLiveMs,
        bufferStartMs,
        progressBarPercent,
        durationPercent,
        formatTimestamp,
        setManualTrack,
        setIsSeeking,
        parseDuration,
        setTimeShiftOffsetSec,
        timeShiftOffsetSec,
        setPlaybackState,
        detachHls,
    } = usePlayerUtils();

    const { isLoggedIn, setUserModalOpen } = useContext(AuthContext);

    const artist = currentTrack?.artist;
    const songTitle = currentTrack?.title;
    const coverUrl = currentTrack?.coverUrl;

    const canvasRef = useAudioVisualizer(audioRef);

    const performSeek = (percent) => {
        // if (!isLoggedIn) {
        //     setUserModalOpen(true);
        //     return;
        // }

        const { maxTimeShiftSeconds, currentLiveTime, history } = nowPlaying || {};

        const audio = audioRef.current;
        if (!audio || !maxTimeShiftSeconds || !currentLiveTime || !history?.length) return;

        const currentLiveMs = new Date(currentLiveTime).getTime();
        const bufferStartMs = currentLiveMs - maxTimeShiftSeconds * 1000;
        const bufferEndMs = currentLiveMs;
        const desiredMs = bufferStartMs + percent * (bufferEndMs - bufferStartMs);

        const seekSec = (desiredMs - bufferStartMs) / 1000;
        const realCurrentTime = timeShiftOffsetSec + audio.currentTime;
        const currentSeekSec = realCurrentTime - maxTimeShiftSeconds + seekSec;

        const newOffset = realCurrentTime - currentSeekSec;
        setTimeShiftOffsetSec(newOffset);

        audio.currentTime = currentSeekSec;
        setCurrentTimeSec(currentSeekSec);

        const seekTimestamp = bufferStartMs + currentSeekSec * 1000;

        const currentSong = history.find(song => {
            const start = new Date(song.startedAt).getTime();
            const end = start + parseDuration(song.duration) * 1000;
            return seekTimestamp >= start && seekTimestamp < end;
        });

        if (currentSong) {
            setManualTrack(currentSong || null);
            setIsSeeking(true);
        }
    };

    const stopPlayback = () => {
        const audio = audioRef.current;
        if (!audio) return;

        audio.pause();
        detachHls();
        setPlaybackState("stopped");
        setCurrentTimeSec(0);
        setTimeShiftOffsetSec(0);
    };

    const stopBtnClassName = playbackState === "stopped" ? "l-btn-disabled l-stop-btn" : "l-stop-btn";

    const modifiedCoverUrl = coverUrl?.includes("default")
        ? coverUrl.replace(".png", "-mid.png")
        : coverUrl;

    return (
        <div className="l-player-colapsed" style={{ opacity: 1 }} >
            <div className="l-colapsed-player">
                <canvas
                    ref={canvasRef}
                    width={340}
                    height={80}
                    className="l-colapsed-analyzer"
                />
                <div className="l-cover-info-btn">
                    <div className="l-colapsed-btn">
                        <div className="l-colapsed-player-btn">
                            <div className="l-progress-ring" style={{ "--percent": `${durationPercent() * 100}%` }}>
                                <button className="l-play-btn" onClick={wrapChildClick(() => togglePlay())}>
                                    {playbackState === "playing"
                                        ? <i className="fas fa-pause"></i>
                                        : <i className="fas fa-play"></i>
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="l-colapsed-info">
                        <div className="l-colapsed-song-info">
                            <div className="l-song-title" title={songTitle}>{songTitle}</div>
                            <div className="l-artist" title={artist}>{artist}</div>
                        </div>
                    </div>
                    <div className="l-colapsed-btn">
                        <div className="l-stop-btn-ring" style={{ "--percent": "100%" }}>
                            <button className={stopBtnClassName} onClick={wrapChildClick(() => stopPlayback())} disabled={playbackState === "stopped"}>
                                <i className="fas fa-stop"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="l-status-progerss">
                    <div className="l-colapsed-times">
                        <div className="l-time">{bufferStartMs ? formatTimestamp(bufferStartMs) : "--:--:--"}</div>
                        <div className="l-time">{currentLiveMs ? formatTimestamp(currentLiveMs) : "--:--:--"}</div>
                    </div>
                    <div className="l-colapsed-progress">
                        <LProgressBar progressPercent={progressBarPercent / 100} onSeek={performSeek} />
                    </div>
                    <div className="l-time l-playbeck-time">
                        <div>
                            {playbackTimeMs ? new Date(playbackTimeMs).toLocaleTimeString("en-GB", { hour12: false }) : "--:--:--"}
                        </div>
                    </div>
                </div>
                <div className="l-colapsed-cover">
                    <img className="l-colapsed-img-cover l-colapsed-fade" src={modifiedCoverUrl} alt="Cover" />
                </div>
                {!expanded &&
                <div className="l-chevron-open-player">
                    <button className="l-chevron-btn" onClick={onTabChevron}>
                        <i className="fa-solid fa-chevron-left"></i>
                    </button>
                </div>}
            </div>
        </div>

    );
}

export default React.memo(LColapsedPlayer);